import { useState } from 'react'
import PwEyeIcon from '@nv/images/design/pw-eye-icon'
import PwEyeSlashIcon from '@nv/images/design/pw-eye-slash-icon'
import clsx from 'clsx'
import { FormikError } from '../formik_error/FormikError'
import { NVButton } from '../nv_button/NVButton'
import styles from './TextField.module.scss'

export const TextField = ({
  formik,
  field,
  placeholder,
  label,
  disabled = false,
  type = 'text',
  isRequired = false,
  isPassword = false,
  classes = {},
  min,
  max,
  maxLength,
  autocomplete,
}: any) => {
  const [passwordVisible, setPasswordVisible] = useState(false)

  return (
    <div className={clsx(styles['container'], classes.container)}>
      {label && (
        <label htmlFor={field} className={clsx(styles['label'], isRequired && styles['required'])}>
          {label}
        </label>
      )}
      <div className={styles['input__container']}>
        <input
          type={isPassword && passwordVisible ? 'text' : isPassword ? 'password' : type}
          placeholder={placeholder}
          className={styles['input']}
          disabled={disabled}
          required={isRequired}
          min={type === 'number' ? min : undefined}
          max={type === 'number' ? max : undefined}
          maxLength={maxLength ? maxLength : undefined}
          {...formik.getFieldProps(field)}
          onChange={(e) => {
            const value = e.target.value
            if (type === 'number' && maxLength && value.length > maxLength) {
              // don't change, maxLength doesn't natively work with type number
            } else {
              formik.setFieldValue(field, value)
            }
          }}
          autoComplete={autocomplete}
        />

        {isPassword && (
          <NVButton
            onClick={() => setPasswordVisible(!passwordVisible)}
            ariaLabel={passwordVisible ? 'Hide password' : 'Show password'}
            icon={!passwordVisible ? <PwEyeIcon /> : <PwEyeSlashIcon />}
            classes={{ container: styles['icon'] }}
          />
        )}
      </div>
      <FormikError formik={formik} fieldName={field} />
    </div>
  )
}

export default TextField
